// extracted by mini-css-extract-plugin
module.exports = {"container":"_2v4a7xLnlpHinHdADAMJXG","playButtonContainer":"PDWyhIWNNtadr2iYJ4Hr4","videospinner":"_2GQ_dY_qV_tkuoSvaif_oX"};